export default __webpack_public_path__ + "static/media/ico-youtube.81f96125.svg";